export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M5.83 10.17a.5.5 0 00-.7 0l-4.1 4.1V11.5a.5.5 0 00-1 0v3.98a.5.5 0 00.5.5H4.5a.5.5 0 000-1H1.73l4.1-4.1a.5.5 0 000-.7zm4.34-4.34a.5.5 0 00.7 0l4.1-4.1V4.5a.5.5 0 101 0V.52a.5.5 0 00-.5-.5H11.5a.5.5 0 000 1h2.77l-4.1 4.1a.5.5 0 000 .7z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "bi bi-arrows-angle-expand",
    "viewBox": "0 0 16 16"
  }
};